import { gql } from "graphql-tag";

/**
 * Shared GraphQL mutation document for triggering proposed answer generation.
 * Import this in both Neptune and Venus instead of defining it twice.
 *
 * `skipSearch` is optional — Neptune passes true to skip the Qdrant search
 * (sources were already loaded on page 1); Venus omits it to run the full pipeline.
 */
export const GENERATE_PROPOSED_ANSWER_MUTATION = gql`
  mutation GenerateProposedAnswer(
    $messageId: UUID!
    $force: Boolean
    $skipSearch: Boolean
  ) {
    messageGenerateProposedAnswer(
      messageId: $messageId
      force: $force
      skipSearch: $skipSearch
    )
  }
`;
